import R from 'ramda';
import constants from 'ha/constants/commonConstants';
import { selectors } from 'ha/modules/AuthLogic';
import { createSelector } from 'reselect';
import getEmailVerified from './getEmailVerified';
import getPhoneNumber from './getPhoneNumber';
import getAvatar from './getAvatar';

const userToStepPairs = [
  ['avatarURL', 'add-profile-picture'],
  ['Phone', 'verify-phone'],
  ['EmailVerified', 'email'],
];

const userFieldCheckers = {
  Phone: Boolean,
  EmailVerified: Boolean,
  avatarURL: v => v && !v.includes(constants.defaultAvatarUrl),
};

const getUnfilledUserFields = user =>
  userToStepPairs.reduce((acc, v) => {
    const [field, name] = v;
    const userValue = user[field];
    const checker = userFieldCheckers[field];

    if (!checker(userValue)) {
      acc.push(name);
    }

    return acc;
  }, []);

export const getMainSteps = createSelector(
  [selectors.getUser, getEmailVerified, getPhoneNumber, getAvatar],
  (user, emailVerified, phone, avatarURL) => {
    const res = getUnfilledUserFields(user);

    if (
      (!R.contains('email', res) || emailVerified) &&
      (!R.contains('verify-phone', res) || phone) &&
      (!R.contains('add-pfofile-picture', res) || avatarURL)
    ) {
      return [...res, 'confirmation'];
    }

    return res;
  },
);

const getShowSuccessStep = R.pathOr(false, [
  'router',
  'location',
  'query',
  'showSuccessStep',
]);

export default R.curry((props, state) => {
  const shouldShowSuccessStep = getShowSuccessStep(props);

  if (
    shouldShowSuccessStep &&
    !getUnfilledUserFields(selectors.getUser(state)).length
  ) {
    return ['confirmation'];
  }

  return ['getting-started', ...getMainSteps(state)];
});
